import { z } from 'zod';
/**
 * Contrats des CLÉS D'API externes read-only (T8, XPHOTO-13). Source unique
 * front + back.
 *
 * Une clé d'API permet à un outil externe d'appeler `/api/v1/*` en LECTURE SEULE,
 * scopé à la bibliothèque de son propriétaire (via le MÊME `AccessControl` que la
 * SPA). Le jeton BRUT (32 octets base64url) n'est jamais persisté : la base ne
 * stocke que son SHA-256. Il n'est renvoyé au client QU'UNE SEULE FOIS, à la
 * création (`apiTokenCreatedSchema.token`) — impossible à ré-afficher ensuite.
 *
 * - `apiTokenSchema`         : item de liste (jamais le jeton brut).
 * - `apiTokenListSchema`     : `{ tokens }`.
 * - `createApiTokenSchema`   : corps de création (`{ label }`).
 * - `apiTokenCreatedSchema`  : réponse de création (item + jeton brut, une fois).
 */
/** Longueur maximale d'un libellé de clé (garde-fou contrat). */
export const API_TOKEN_LABEL_MAX = 120;
/**
 * Item de clé d'API (`GET /api/api-tokens`) — jamais le jeton brut ni son hash.
 * `revokedAt` non nul = clé révoquée (conservée pour l'historique, inutilisable).
 */
export const apiTokenSchema = z.object({
    id: z.uuid(),
    label: z.string(),
    createdAt: z.string().datetime({ offset: true }),
    /** Dernière utilisation (mise à jour à chaque appel `/api/v1/*`), ou `null`. */
    lastUsedAt: z.string().datetime({ offset: true }).nullable(),
    /** Date de révocation (soft), ou `null` si la clé est active. */
    revokedAt: z.string().datetime({ offset: true }).nullable(),
});
/** Liste des clés d'API du compte courant. */
export const apiTokenListSchema = z.object({
    tokens: z.array(apiTokenSchema),
});
/** Corps de `POST /api/api-tokens` : un libellé lisible, non vide, borné. */
export const createApiTokenSchema = z.object({
    label: z.string().trim().min(1).max(API_TOKEN_LABEL_MAX),
});
/**
 * Réponse de `POST /api/api-tokens` : l'item créé + le JETON BRUT.
 *
 * ⚠ `token` n'est renvoyé QUE par cette réponse, UNE SEULE FOIS : il n'est jamais
 * stocké en clair ni ré-affichable ensuite. Le client doit inviter l'utilisateur
 * à le copier immédiatement.
 */
export const apiTokenCreatedSchema = z.object({
    token: apiTokenSchema,
    /** Jeton brut (base64url), affiché une seule fois côté client. */
    secret: z.string(),
});
//# sourceMappingURL=api-token.js.map